import {OEAnalyticsEventDataParamName} from './oe-analytics-model';

export class OEAnalyticsTool   {

    constructor()   {
    }

    get isAvailable() {
        return !!global.umami;
    }

    track(eventName, eventData, target, version)    {
        if(!this.isAvailable)   return;
        eventData = eventData || {};
        if(typeof(target) === 'string')     eventData[OEAnalyticsEventDataParamName.target] = target;
        if(typeof(version) === 'string')    eventData[OEAnalyticsEventDataParamName.version] = version;

        //console.log(`Web: OEAnalyticsTool - track - ${eventName}`);

        global.umami.track(eventName, eventData);
    }
};

export default new OEAnalyticsTool();